export default {
  en: {
    actionsForWord: 'Actions for word "{{word}}"',
    stopPronunciation: 'Stop pronunciation',
    pronunciation: 'Pronunciation',
    showTranslation: 'Show translation',
    stampAgain: "Don't remember",
    stampKnow: 'Remember',
    stampKnowForSure: "Definitely know, don't show again",
    actionsSheetTitle: 'Actions',
    reportTranslation: 'Report incorrect translation',
    reportThanks: "Thanks, we'll look into it!",
  },
  ru: {
    actionsForWord: 'Действия со словом «{{word}}»',
    stopPronunciation: 'Остановить произношение',
    pronunciation: 'Произношение',
    showTranslation: 'Показать перевод',
    stampAgain: 'Не помню',
    stampKnow: 'Помню',
    stampKnowForSure: 'Знаю, больше не показывать',
    actionsSheetTitle: 'Действия',
    reportTranslation: 'Сообщить о неправильном переводе',
    reportThanks: 'Спасибо, разберёмся!',
  },
};
